import React from 'react';
const CART_URL = 'https://fbwqku-s9.myshopify.com/cart/52013268271396:1';
interface UrgentCTAProps {
  children: React.ReactNode;
  onClick?: () => void;
  size?: 'default' | 'large';
  className?: string;
}
export function UrgentCTA({
  children,
  onClick,
  size = 'default',
  className = ''
}: UrgentCTAProps) {
  const sizeClasses = size === 'large' ? 'text-xl md:text-2xl px-8 md:px-12 py-5 md:py-6' : 'text-lg md:text-xl px-6 md:px-8 py-4 md:py-5';
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
    // Navigate to checkout
    window.location.href = CART_URL;
  };
  return <button onClick={handleClick} className={`
        w-full bg-gradient-to-r from-pink-500 to-rose-500 hover:from-pink-600 hover:to-rose-600 text-white font-extrabold uppercase
        rounded-lg shadow-2xl transition-all duration-200
        animate-pulse-urgent animate-glow
        border-4 border-pink-600
        ${sizeClasses}
        ${className}
      `} aria-label={typeof children === 'string' ? children : undefined} data-id="element-262">
      {children}
    </button>;
}